export const mockData = [
  {
    quote:
      "Boosted sales by 50%! That's Jane's success story with our service. Join in!",
    name: 'Sarah Rose Siskind',
    title: 'Founder',
    image: '/assets/images/avatar/customer-avatar1.jpg',
    logo: '/assets/images/ark-logo.svg',
  },
  {
    quote: 'We have generated 50+ leads over the past six months.',
    name: 'Simon Goulet',
    title: 'Co-Founder',
    image: '/assets/images/avatar/customer-avatar2.jpg',
    logo: '/assets/images/ark-logo.svg',
  },
  {
    quote: 'The engagement has led to significant numbers of meetings.',
    name: 'Rich Ellor',
    title: 'VP of Marketing',
    image: '/assets/images/avatar/customer-avatar3.jpg',
    logo: '/assets/images/ark-logo.svg',
  },
  {
    quote: 'Their understanding of our priorities was impressive.',
    name: 'Sancho Requejo',
    title: 'International Sales Manager',
    image: '/assets/images/avatar/customer-avatar4.jpg',
    logo: '/assets/images/ark-logo.svg',
  },
  {
    quote: 'We have generated 50+ leads over the past six months.',
    name: 'Simon Goulet',
    title: 'Co-Founder',
    image: '/assets/images/avatar/customer-avatar2.jpg',
    logo: '/assets/images/ark-logo.svg',
  },
  {
    quote: 'The engagement has led to significant numbers of meetings.',
    name: 'Rich Ellor',
    title: 'VP of Marketing',
    image: '/assets/images/avatar/customer-avatar3.jpg',
    logo: '/assets/images/ark-logo.svg',
  },
  {
    quote: 'Their understanding of our priorities was impressive.',
    name: 'Sancho Requejo',
    title: 'International Sales Manager',
    image: '/assets/images/avatar/customer-avatar4.jpg',
    logo: '/assets/images/ark-logo.svg',
  },
  {
    quote:
      "Boosted sales by 50%! That's Jane's success story with our service. Join in!",
    name: 'Sarah Rose Siskind',
    title: 'Founder',
    image: '/assets/images/avatar/customer-avatar1.jpg',
    logo: '/assets/images/ark-logo.svg',
  },
];
